import allClassJobs from "./data/classJobNames.json";

const BASE_URL = "https://xivcalling.fly.dev/api";

// Fetches data about a given character from scraping Lodestone.
// This does NOT handle updating the view, only getting the data.
export async function getCharacter(id) {
  const resp = await fetch(`${BASE_URL}/${id}`);
  const data = await resp.json();
  return parseCharacterData(data);
};

// Takes the Lodestone data and shapes it into something useful for us.
function parseCharacterData(data) {
  if (!(data && data["status"] && data["status"] === "success"))
    return data;

  const {classjob, server, ...formattedData} = keysToLowerCase(data);
  const jobs = parseClassJobData(classjob);
  const serverFormat = parseServerData(server);

  return Object.assign({}, formattedData, serverFormat, { jobs: jobs });
};

function keysToLowerCase(data) {
  return Object.fromEntries(
    Object.entries(data).map(([k, v]) => [k.toLowerCase(), v])
  );
};

function parseClassJobData(classJobData) {
  return allClassJobs.reduce(
    (acc, job) => {
      acc[job.jobShort] = buildJobObject(job, classJobData);
      return acc;
    }, {});
};

function parseServerData(server) {
  const str = server.replace('[', '(').replace(']', ')')
  return {server: str};
}

function buildJobObject({jobName, jobShort, className, classShort, role}, classJobData) {
  const isClass = classJobData[jobName] === undefined && classJobData[className];
  const level = (isClass ? classJobData[className] : classJobData[jobName])["Level"];
  return {
    name: isClass ? className : jobName,
    abbrev: isClass ? classShort : jobShort,
    level,
    role,
  }
};
